import React, { useEffect, useState } from "react";
import { FlatList, ImageBackground, ActivityIndicator, StyleSheet, Switch, Text, TouchableOpacity, View } from "react-native";
import { MyButton } from "./buttonsAndControls";
import { Checkbox, IconButton, TextInput } from "react-native-paper";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import DateModule from "./mainAppDateModule"
import { header, stopCodes } from "./StockAwareTempData";
const darkColour='#2a2d3e';

interface ChildViewData {
  id: number;
  texts: string[];
}


interface StockList {
  ID: number;
  Quantity: number;
  Item_Name: string;
  Vendor: string;
  Last_Updated: string;
  Amount_Paid: number;
  Notes: string
  Item_Price: number;
}


const ChildView = ({texts, isChecked, onCheckboxChange, showCheckbox, index,
}: ChildViewData & { isChecked: boolean; onCheckboxChange: (value: boolean) => void; showCheckbox: boolean; index: number; }) => {
  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const remarkWidth= showCheckbox ? 422 : 458;
  const sizes: number[] = [57, 350, 230, 200, remarkWidth, 120, 157];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity style={{...stylesBox.childTouchable, backgroundColor: isChecked ? darkColour : 'transparent'}}
      	onPress={() => onCheckboxChange(!isChecked)}>
				{showCheckbox && (
					<Checkbox
						status={isChecked ? 'checked' : 'unchecked'}
						onPress={() => onCheckboxChange(!isChecked)}
						color='white'
					/>
				)}
				{texts.map((text, i) => (
					<View key={i} style={{...stylesBox.childBoxes, width: sizes[i]}}>
						<Text key={i} style={{...stylesBox.childText,  color: isChecked ? 'white' : darkColour}}>
							{text}
						</Text>
					</View>
				))}
      </TouchableOpacity>
    </View>
  );
};


const PurchaseRecord = () => {
	header('Purchase History')
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [markedID, setMarkedID] = useState<boolean[]>([]);
	const [filteredResult, setFilteredResult] = useState<StockList[]>([]);
	const [stocks, setStocks] = useState<StockList[]>([]);
	const [deleteArrayID, setDeleteArrayID] = useState<number[]>([]);
  const [grossTotal, setGrossTotal] = useState(' ');
	const [whoClicked, setWhoClicked] = useState('this month')
	const [customDate, setCustomDate] = useState(false)
	const [footerText, setFooterText] = useState('Showing from this month')
	const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
	const [totalRows, setTotalRows] = useState(-1);
	const [holdTotal, setHoldTotal] = useState(' ');
	const stocksArray: StockList[] = [];
	const [dateVisible, setDateVisible] = useState(false);
	let timeout: NodeJS.Timeout
	
  const fetchStocks = async () => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `SELECT * FROM Purchase_Record WHERE strftime('%Y-%m', Last_Updated) = strftime('%Y-%m', 'now') ORDER BY ID DESC`,
        [],
        (_, results) => {
          const rows = results.rows;
					setTotalRows(rows.length)
          const stocksArray: StockList[] = [];
          for (let i = 0; i < rows.length; i++) {
            stocksArray.push(rows.item(i) as StockList);
          }
          setStocks(stocksArray);
					setFilteredResult(stocksArray);

          // Setting all checked items to false
					const updatedCheckedItems: boolean[] = Array.from(
						{ length: stocksArray.length },
						() => false
					);
					setCheckedItems(updatedCheckedItems)
					
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  useEffect(() => {
		if (stopCodes) {
    	try {
      	fetchStocks();
			
      } catch (error) {
        console.log(error)
      
      }
		}
    }, [stopCodes]);

		useEffect(() => {
			if (stopCodes) {
				timeout = setTimeout(() => {
					if (totalRows !== -1 && filteredResult.length === totalRows) {
						setShowLoadingIndicator(true)
					}
				}, 10000);
				if (totalRows !== -1 && filteredResult.length === totalRows) {
					clearTimeout(timeout)
					setTimeout(() => {
							setShowLoadingIndicator(false)
					}, 200);
				}
			}
		}, [totalRows, filteredResult, stopCodes]);

		useEffect(() => {
			if (stopCodes) {
				const filterChildViews = async () => {
					const filteredViews = await filterViews() as StockList[];
					setFilteredResult(filteredViews);
				};
				filterChildViews();
			}
		}, [stocks, checkedItems, isSwitchOn, searchText, stopCodes]);

		useEffect(() => {
			if (stopCodes && totalRows !== -1) {
				let amt = 0
				for (const entry of filteredResult) {
					amt += (entry.Amount_Paid * entry.Quantity)
				}
				setGrossTotal(amt.toString())
			}
		}, [stopCodes, filteredResult]);


		const findIndexById = (array: any[], id: number | string): number => {
			return array.findIndex((item) => item.ID === id);
		};
	
		const handleCheckboxChange = (index: number, value: boolean, id: number) => {
			const updatedCheckedItems = [...checkedItems];
			updatedCheckedItems[index] = value;
			setCheckedItems(updatedCheckedItems);
	
			const idIndex = findIndexById(stocks, id);
			const updatedMarkedID = [...markedID];
			updatedMarkedID[idIndex] = value;
			
			setMarkedID(updatedMarkedID);
			if (deleteArrayID.includes(id)) {
        setDeleteArrayID((prevDel) => prevDel.filter((value) => value !== id));
      } else {
      setDeleteArrayID((prevDel) => [...prevDel, id]);
      };
		};

  
  const handleSearchTextChange = (value: string) => {
    setSearchText(value);
		
  };

  const filterData = (query: string) => {
    const filteredResults = stocks.filter((item) =>
      item.Item_Name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredResult(filteredResults);
  };

  const filterViews = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredViews = stocks.filter((child) => {
          const hasTextMatch = (child.Item_Name.toLowerCase() + (child.Vendor ? child.Vendor.toLowerCase() 
					: '') + (child.Notes ? child.Notes.toLowerCase() : '')).includes(searchText.toLowerCase())
          const hasIdMatch = child.ID.toString().includes(searchText.toLowerCase());
          return hasTextMatch || hasIdMatch;
					
        });

        resolve(filteredViews);
      }, 0);
    });
  };

  const deleteCheckedItems = () => {
		const updatedCheckedItems = checkedItems.filter((_, index) => !checkedItems[index]);
    const updatedChildViews = stocks.filter((_, index) => !markedID[index]);
	
    setCheckedItems(updatedCheckedItems);
    setStocks(updatedChildViews);
		setMarkedID([]);

    markedForDelete();
  };

  const markedForDelete = async () => {
    DEBUG(true);
    enablePromise(true);
    const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
      deleteArrayID.forEach((row) => {
        tx.executeSql(
          `DELETE FROM Purchase_Record WHERE ID = ?;`,
          [row],
          (_, results) => {
          if (results.rowsAffected > 0) {
            console.log('Deleted Successfully')
          }
            
          },
          (error) => {
            console.error('Error executing SQL', error);
          }
        );
      })
    })
    setDeleteArrayID([])
  }

  const onToggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

	function getOrdinalSuffix(number: number): string {
    if (number >= 11 && number <= 13) {
      return number + 'th';
    } else {
      const lastDigit = number % 10;
      switch (lastDigit) {
        case 1:
          return number + 'st';
        case 2:
          return number + 'nd';
        case 3:
          return number + 'rd';
        default:
          return number + 'th';
      }
    }
  };

	const searchDateSelected = async (start: string, end: string, month: string, monthName: string, year: string) => {
		if (end !== '00') {
			setFooterText(
				`Showing from ${getOrdinalSuffix(parseInt(start, 10))} ${monthName}, ${year} to ${getOrdinalSuffix(parseInt(end, 10))} ${monthName}, ${year}`
				)
			setShowLoadingIndicator(true)
			setGrossTotal(' ')
			setCustomDate(true)
			DEBUG(true);
			enablePromise(true);
			const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
			(await initDB).transaction((tx) => {
				tx.executeSql(
					`SELECT * FROM Purchase_Record WHERE Last_Updated BETWEEN '${year}-${month}-${start} 00:00:00' AND '${year}-${month}-${end} 23:59:59' ORDER BY ID DESC`,
					[],
					(_, results) => {
						const rows = results.rows;
					setTotalRows(rows.length)
						for (let i = 0; i < rows.length; i++) {
							stocksArray.push(rows.item(i) as StockList);
						}
						setStocks(stocksArray);
						setFilteredResult(stocksArray);
						const updatedCheckedItems: boolean[] = Array.from(
							{ length: stocksArray.length },
							() => false
						);
						setCheckedItems(updatedCheckedItems)
						
					},
					(error) => {
						console.error('Error executing SQL', error);
					}
				);
			})
		}
	}

	const thisMonthClicked = async () => {
		setTimeout(async () => {
			if (whoClicked !== 'this month') {
				setFooterText('Showing from this month')
				setWhoClicked('this month')
				setShowLoadingIndicator(true)
				setGrossTotal(' ')
				setDateVisible(false)
				setCustomDate(false)
				DEBUG(true);
				enablePromise(true);
				const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
				(await initDB).transaction((tx) => {
					tx.executeSql(
						`SELECT * FROM Purchase_Record WHERE strftime('%Y-%m', Last_Updated) = strftime('%Y-%m', 'now', '+1 hour') ORDER BY ID DESC`,
						[],
						(_, results) => {
							const rows = results.rows;
						setTotalRows(rows.length)
							for (let i = 0; i < rows.length; i++) {
								stocksArray.push(rows.item(i) as StockList);
							}
							setStocks(stocksArray);
							setFilteredResult(stocksArray);
							const updatedCheckedItems: boolean[] = Array.from(
								{ length: stocksArray.length },
								() => false
							);
							setCheckedItems(updatedCheckedItems)
							
						},
						(error) => {
							console.error('Error executing SQL', error);
						}
					);
				})
			} 
		}, 100);
		
	}

	const lastMonthClicked = async () => {
		setTimeout( async() => {
			if (whoClicked !== 'last month') {
				setFooterText('Showing from last month')
				setWhoClicked('last month')
				setShowLoadingIndicator(true)
				setGrossTotal(' ')
				setDateVisible(false)
				setCustomDate(false)
				DEBUG(true);
				enablePromise(true);
				const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
				(await initDB).transaction((tx) => {
					tx.executeSql(
						`SELECT * FROM Purchase_Record WHERE strftime('%Y-%m', Last_Updated) = strftime('%Y-%m', 'now', '-1 month', '+1 hour') ORDER BY ID DESC`,
						[],
						(_, results) => {
							const rows = results.rows;
						setTotalRows(rows.length)
							for (let i = 0; i < rows.length; i++) {
								stocksArray.push(rows.item(i) as StockList);
							}
							setStocks(stocksArray);
							setFilteredResult(stocksArray);
							const updatedCheckedItems: boolean[] = Array.from(
								{ length: stocksArray.length },
								() => false
							);
							setCheckedItems(updatedCheckedItems)
							
						},
						(error) => {
							console.error('Error executing SQL', error);
						}
					);
				})
			}
		}, 100);
		
				
	}

	const customClicked = () => {
		setWhoClicked('custom')
		setDateVisible(true)
	}

  const switchText = isSwitchOn ? 'Checkbox shown' : 'Checkbox hidden';


	return (
		<View style={{ flex: 1 }}>
      <View style={stylesBox.mainView}>
				<View style={stylesBox.headerContainer}>
					<View style={stylesBox.textInputMasterContainer}> 
						<TextInput
							mode="outlined"
							label={'Search record'}
							placeholder="Search"
							underlineColor={darkColour}
							activeOutlineColor={darkColour}
							spellCheck={false}
							contentStyle={stylesBox.searchTextInput} 
							style={{marginTop:-1, height:30 }}
							outlineStyle={{ borderWidth: 0, height:30, borderRightColor:'white', }}
							onChangeText={handleSearchTextChange}
						/>

						<View style={stylesBox.daySelect}>
							<MyButton btnText="This month"
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={2}
								btnColor={whoClicked === 'this month' ? darkColour : 'white'}
								btnFontSize={15}
								btnHeight={32}
								btnWidth={95}
								btnTxtClr={whoClicked === 'this month' ? 'white' : darkColour}
								btnPadding={4}
								hndClicked={thisMonthClicked}
							/>
						</View>

						<View style={stylesBox.daySelect}>
							<MyButton 
								btnText="Last month" 
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={2}
								btnColor={whoClicked === 'last month' ? darkColour : 'white'}
								btnFontSize={15}
								btnHeight={32}
								btnWidth={95}
								btnTxtClr={whoClicked === 'last month' ? 'white' : darkColour}
								btnPadding={4}
								hndClicked={lastMonthClicked}
							/>
						</View>

						<View style={{...stylesBox.daySelect, width:110}}>
							<MyButton 
								btnText="Custom date" 
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={2}
								btnColor={whoClicked === 'custom' ? darkColour : 'white'}
								btnFontSize={15}
								btnHeight={32}
								btnWidth={110}
								btnTxtClr={whoClicked === 'custom' ? 'white' : darkColour}
								btnPadding={4}
								hndClicked={customClicked}
							/>
						</View>
					</View>
				</View>
						
				<View style={stylesBox.deleteContainer}>
					{checkedItems.some((item) => item) && (
						<View style={{alignSelf:'flex-end'}}>
							<MyButton 
								btnText ="Delete Selected"
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={0}
								btnColor={darkColour}
								btnFontSize={15}
								btnHeight={40}
								btnTxtClr="white"
								hndClicked={deleteCheckedItems}
							/>
						</View>
					)}		
				</View>
      </View>

				<View style={stylesBox.mainDataView}>
					<View style={stylesBox.headerBox}>
						<View style={{ ...stylesBox.columnHeaderBox, marginLeft: isSwitchOn ? 36 : 0, borderLeftWidth:0 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
						</View>
						<View style={{ ...stylesBox.columnHeaderBox, width: 350 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Board Description</Text>
						</View>
						<View style={{ ...stylesBox.columnHeaderBox, width: 230 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Vendor</Text>
						</View>
						<View style={{ ...stylesBox.columnHeaderBox, width: 200 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Date and Time</Text>
						</View>
						<View style={{ ...stylesBox.columnHeaderBox, width: isSwitchOn ? 422 : 458 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Notes</Text>
						</View>
						<View style={{ ...stylesBox.columnHeaderBox, width: 120 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Cost (₦)</Text>
						</View>
						<View style={{ ...stylesBox.columnHeaderBox, width: 136, borderRightWidth:0 }}>
							<Text style={{ ...stylesBox.columnHeaderText }}>Total Cost (₦)</Text>
						</View>
					</View>
						{ showLoadingIndicator  ? (
						<ActivityIndicator size="large" color= {darkColour} style ={{ marginTop: 280}} />
							) : (
								<FlatList
									data={filteredResult}
									keyExtractor={(item) => item.ID.toString()}
									renderItem={({ item, index }) => (
										<ChildView
											key={item.ID}
											texts={[
												item.Quantity.toString(),
												item.Item_Name,
												item.Vendor ? item.Vendor : 'Undefined',
												item.Last_Updated,
												item.Notes ? item.Notes : ' ',
												item.Amount_Paid ? Number(item.Amount_Paid).toLocaleString('en-NG') : '0.00',
												isNaN(item.Amount_Paid) ? '0.00' : Number(item.Amount_Paid * item.Quantity).toLocaleString('en-NG'),
											]}
											isChecked={deleteArrayID.includes(item.ID) ? true : false}
											onCheckboxChange={(value) => handleCheckboxChange(index, value, item.ID)}
											showCheckbox={isSwitchOn}
											index={index}
											id={item.ID}
										/>
									)}
								/>
							)
						}
				</View>
				{dateVisible &&
				<View style={stylesBox.dateContainer}>
					<DateModule appearUp ={false} onNewDateSelected={searchDateSelected}/>
				</View> 
				}
				<View style={stylesBox.footerMainContainer}>
					<View style={stylesBox.footerSub}>
						<View>
							<View style={{height: 40, flexDirection: 'row'}}>
								<View style={stylesBox.footerLeftContainer}>
									<Text style={{...stylesBox.columnHeaderText, color:'white', paddingTop:3}}>
										{footerText}
									</Text>
								</View>
								<View style={stylesBox.footerRightContainer}>
									<Text style={{...stylesBox.columnHeaderText, color:'white', paddingTop:3}}>
										Gross Sales Revenue for this duration 
									</Text>
									<IconButton
										icon="ray-start-arrow"
										iconColor= 'white'
										size={40}
										focusable={false}
										style={{marginHorizontal:20, marginTop:-8}}
									/>
								</View>
							</View>
						</View>
				
				<View style={stylesBox.totalMainContainer}>
					<View style={stylesBox.totalContainer}>
            <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900'}}>
              {Number(grossTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
            </Text>
					</View>
				</View>
			</View>
		</View>
  </View>
	)
};

const stylesBox=StyleSheet.create ({
	columnHeaderText: {
		fontFamily:'century gothic', 
		fontSize:15, 
		fontWeight:'normal', 
		textAlign:'center',
		color:'white', 
		marginTop:6
	},
	columnHeaderBox: {
		borderWidth:2, 
		borderColor:'black', 
		width:57,  
		height:'100%', 
		alignItems:'center',
		marginLeft:-2,
		borderTopWidth:0,
	},
	mediumText: {
		color:'grey', 
		fontFamily:'century gothic', 
		fontSize:15, 
		fontWeight:'normal', 
		textAlign:'center',
		marginTop:5
	},
	mainView: {
		flexDirection: 'row', 
		backgroundColor: 'white', 
		borderWidth: 2, 
		borderRadius: 10, 
		marginLeft: 20, 
		marginRight: 20, 
		borderColor: '#DCE3E8',
	},
	firstSubView: {
		borderWidth: 2,
		borderRadius: 10,
		borderColor: '#DCE3E8',
		flexDirection: 'row',
		alignSelf: 'center',
		alignContent: 'center',
		width: 208,
		height: 40,
		margin: 20,
		marginTop: 0,
		marginBottom: 0
	},
	daySelect: {
    alignSelf:'center', 
    marginLeft:-2, 
    height:40, 
    width:95,
    borderWidth:2, 
    borderColor: 'transparent', 
    borderTopRightRadius:10,
    borderBottomRightRadius:10, 
    marginRight:10, 
    borderLeftWidth:0, 
    marginTop:0, 
    alignContent:'center'
  },
  searchTextInput: {
    paddingTop: 2, 
    paddingBottom:0,
    borderWidth:2, 
    borderRightWidth:0,
    borderRightColor:'white',
    width: 300, 
    height:30, 
    borderRadius:10, 
    borderTopRightRadius:0,
    borderBottomRightRadius:0,
    borderColor: 'transparent',
  },
	headerContainer: {
		flexDirection:'column', 
		backgroundColor:'white', 
		alignSelf:'center', 
		borderWidth:2, 
		borderColor: '#DCE3E8', 
		borderRadius:10, 
		marginLeft:10, 
		marginTop:10, 
		marginBottom:10, 
		width:634, 
		height:40,
	},
	textInputMasterContainer: {
		flexDirection:'row', 
		width:634, 
		height:40
	},
	mainDataView: {
		flex:1, 
		height:500, 
		borderWidth:2, 
		borderBottomWidth:0,
		borderColor:'#DCE3E8', 
		marginTop:10, 
		marginBottom:0, 
		borderRadius:10,
		borderBottomLeftRadius:0,
		borderBottomRightRadius:0,
		marginLeft:20, 
		marginRight:20, 
		backgroundColor:'white'
	},
	headerBox: {
		width:'100%', 
		height:35, 
		backgroundColor: darkColour, 
		flexDirection:'row', 
		borderTopLeftRadius:10, 
		borderTopRightRadius:10
	},
	deleteContainer: {
		flex:1, 
		backgroundColor:'white', 
		alignSelf:'center', 
		paddingRight:20
	},
	dateContainer: {
		marginTop:-60, 
		marginLeft:-190, 
		top:72, 
		left: 880, 
		position: 'absolute'
	},
	footerMainContainer: {
		height:40, 
		marginLeft:20, 
		marginRight:20, 
		marginBottom:10, 
		borderRadius:10, 
		borderTopRightRadius:0,
		borderTopLeftRadius:0,
		borderWidth:2, 
		borderTopWidth:0,
		borderColor:'#DCE3E8',
		backgroundColor: darkColour,
		alignItems:'center'
	},
	footerLeftContainer: {
		alignSelf:'flex-start', 
		alignItems: 'flex-start', 
		marginLeft:20, 
		height:28, 
		width:612,
	},
	footerSub: {
		flexDirection:'row', 
		alignSelf:'center'
	},
	footerRightContainer: {
		flexDirection:'row', 
		height:54, 
		width:613, 
		alignSelf:'flex-start', 
		justifyContent: 'flex-end',
	},
	totalContainer: {
		flexDirection:'row', 
		justifyContent:'center', 
		borderWidth:2, 
		borderLeftWidth:0, 
		borderRightWidth:0, 
		marginTop:2, 
		borderColor:'white', 
		width:152, 
		height:35, 
		alignSelf:'flex-end', 
	},
	totalMainContainer: {
		height: 40, 
		width:311, 
		alignItems:'center'
	},
	childTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
	childBoxes: {
		borderWidth: 2, 
		borderColor: 'black', 
		height: '100%', 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
	},
	childText: {
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 6,
	}
			
	})

export default PurchaseRecord